import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ y: 40, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={`relative ${className}`}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs font-mono uppercase tracking-[0.25em] text-gold mb-6">{children}</p>
);
